"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapJob = exports.default = exports.MatchesContext = exports.MatchesActionsContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _trackingService = require("@jobmatchme/frontend-analytics/es/trackingService.js");

var _Pc = require("@jobmatchme/amplify-tools/es/api/Pc");

var _package = require("../../../package.json");

var _reactI18next = require("react-i18next");

var _getConfig = _interopRequireDefault(require("@jobmatchme/profile-components/es/resources/getConfig"));

var _getkmfromcoord = _interopRequireDefault(require("../../utils/getkmfromcoord"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var displayPrimaryAttribute = function displayPrimaryAttribute(discriminator, attribute, value, t) {
  return value && value.length > 0 ? ' (' + value.map(function (key) {
    return t && t("profile-properties:".concat(discriminator, ".").concat(attribute, ".").concat(key));
  }).join(', ') + ')' : '';
};

var dotAccess = function dotAccess(object, value) {
  return value.backend.split('.').reduce(function (current, key) {
    return current && current[key];
  }, object) || value.default;
};

var special = {
  workTimes: function workTimes(value) {
    var result = [];

    if (value.minimum === 20) {
      result.push('PART_TIME');
    }

    if (value.maximum === 40) {
      result.push('FULL_TIME');
    }

    return result;
  }
};

var mapJob = function mapJob(searchProfile, configData, t) {
  return function (match) {
    var backend = {
      searchProfile: searchProfile,
      match: match
    };
    var discriminator = match.joboffer.discriminator;
    var primaryAttributeKey = (0, _getConfig.default)(discriminator)('bc').view.primaryAttribute;
    var primaryAttributeValue = match.joboffer[primaryAttributeKey];
    return (0, _extends2.default)({
      jobId: match.jobId,
      bcId: match.bcId,
      bookingId: match.bookingId,
      diagnosticFit: match.diagnosticFit,
      revision: match.revision,
      primaryAttributeDisplay: displayPrimaryAttribute(discriminator, primaryAttributeKey, primaryAttributeValue, t),
      bcName: match.joboffer.bcName,
      displayName: match.displayName,
      locationName: match.joboffer.location ? match.joboffer.location.name : '',
      discriminator: discriminator
    }, configData.global.reduce(function (result, globalAttribute) {
      result[globalAttribute.key] = dotAccess(backend, globalAttribute);
      return (0, _extends2.default)({}, result);
    }, {}), {
      cardLines: configData.cardLines.map(function (cardLine) {
        var text = {};

        if ('tKey' in cardLine && cardLine.tKey) {
          text = {
            tKey: cardLine.tKey
          };
        } else if ('special' in cardLine && cardLine.special) {
          var specialCase = cardLine.key ? special[cardLine.key] : function () {
            return undefined;
          };
          text = {
            label: cardLine.key,
            keys: specialCase(dotAccess(backend, cardLine))
          };
        } else if ('key' in cardLine && cardLine.key) {
          text = {
            label: cardLine.key,
            keys: dotAccess(backend, cardLine)
          };
        } else if ('backend' in cardLine) {
          text = dotAccess(backend, cardLine);
        }

        return {
          icon: cardLine.icon,
          text: text,
          matchingScore: 'key' in cardLine && cardLine.key ? match.matchingScores[cardLine.key] : undefined // Can be undefined

        };
      }),
      previewLines: configData.previewLines.map(function (previewLine) {
        var text = {};

        if ('tKey' in previewLine && previewLine.tKey) {
          text = {
            tKey: previewLine.tKey
          };
        } else if ('special' in previewLine && previewLine.special) {
          var specialCase = previewLine.key ? special[previewLine.key] : function () {
            return undefined;
          };
          text = {
            label: previewLine.key,
            keys: specialCase(dotAccess(backend, previewLine))
          };
        } else if ('key' in previewLine && previewLine.key) {
          text = {
            label: previewLine.key,
            keys: dotAccess(backend, previewLine)
          };
        } else if ('backend' in previewLine) {
          text = dotAccess(backend, previewLine);
        }

        return {
          icon: previewLine.icon,
          text: text,
          matchingScore: 'key' in previewLine && previewLine.key ? match.matchingScores[previewLine.key] : undefined,
          // Can be undefined
          primary: previewLine.primary || false
        };
      }),
      descriptionLines: configData.descriptionLines.map(function (descriptionLine) {
        var text;

        if (descriptionLine.key) {
          text = {
            label: descriptionLine.key,
            keys: dotAccess(backend, descriptionLine)
          };
        } else {
          text = dotAccess(backend, descriptionLine);
        }

        return {
          header: descriptionLine.header,
          text: text
        };
      })
    });
  };
};

exports.mapJob = mapJob;

var MatchesContext = /*#__PURE__*/_react.default.createContext({
  status: 'initial',
  list: [],
  newMatches: []
});

exports.MatchesContext = MatchesContext;

var MatchesActionsContext = /*#__PURE__*/_react.default.createContext({
  fetchMatches: function fetchMatches() {
    return Promise.reject();
  },
  executeWhileLoading: function executeWhileLoading() {
    return Promise.reject();
  }
}); // we need this for our new matches notification


exports.MatchesActionsContext = MatchesActionsContext;
var matchesLoadingCounter = 0;

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_MATCHES_START':
    case 'SET_STATUS_LOADING':
      return (0, _extends2.default)({}, state, {
        status: 'loading'
      });

    case 'SET_STATUS_DONE':
      return (0, _extends2.default)({}, state, {
        status: 'done'
      });

    case 'FETCH_MATCHES_SUCCESS':
      var hasNewMatches;

      if (action.payload.length > 0 && matchesLoadingCounter > 1) {
        hasNewMatches = action.payload.filter(function (_ref) {
          var jobId1 = _ref.jobId;
          return !state.list.some(function (_ref2) {
            var jobId2 = _ref2.jobId;
            return jobId2 === jobId1;
          });
        });
      }

      matchesLoadingCounter++;
      return {
        list: action.payload,
        status: 'done',
        newMatches: hasNewMatches
      };

    default:
      throw new Error('Undefined reducer action');
  }
};

var MatchesProvider = function MatchesProvider(_ref3) {
  var children = _ref3.children,
      matchingConfig = _ref3.matchingConfig,
      _ref3$initialMatches = _ref3.initialMatches,
      initialMatches = _ref3$initialMatches === void 0 ? [] : _ref3$initialMatches;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useReducer = (0, _react.useReducer)(reducer, {
    status: 'initial',
    list: [],
    newMatches: []
  }),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      matches = _useReducer2[0],
      dispatch = _useReducer2[1]; // internal state


  var jobofferDistances = function jobofferDistances(data) {
    return data && data.length > 1 ? data.map(function (j) {
      return {
        // Calculate distance
        distance: (0, _getkmfromcoord.default)(j.searchLocation ? j.searchLocation.latitude : 0, j.searchLocation ? j.searchLocation.longitude : 0, j.jobLocation ? j.jobLocation.latitude : 0, j.jobLocation ? j.jobLocation.longitude : 0).toFixed(0),
        jobId: j.jobId
      };
    }) : {};
  };

  var fetchMatches = (0, _react.useCallback)(function (profile, maybeOptimisticMatches) {
    var trackMatches = function trackMatches(pcUuid, matches, jobofferDistances) {
      (0, _trackingService.trackEvent)({
        eventName: 'matchList',
        pcUuid: pcUuid,
        payload: {
          matches: matches,
          profile: profile,
          jobofferDistances: jobofferDistances,
          version: _package.version
        }
      });
    };

    dispatch({
      type: 'FETCH_MATCHES_START'
    }); // If we have optimistic matches, use them

    return (maybeOptimisticMatches ? Promise.resolve(maybeOptimisticMatches) : _Pc.PcApi.post('/matchingService/matchProfile', profile)).then(function (matches) {
      var mappedMatches = matches.map(mapJob(profile, matchingConfig, t));
      dispatch({
        type: 'FETCH_MATCHES_SUCCESS',
        payload: mappedMatches
      });

      _Pc.PcApi.auth().then(function (PcAuth) {
        return PcAuth.currentAuthenticatedUser().then(function (user) {
          mappedMatches && trackMatches(user.username, matches, jobofferDistances(mappedMatches));
        });
      });

      return mappedMatches;
    });
  }, [matchingConfig, t]);
  var executeWhileLoading = (0, _react.useCallback)(function (promises) {
    dispatch({
      type: 'SET_STATUS_LOADING'
    });
    return promises.reduce(function (chain, promise) {
      return chain.then(function (r) {
        return promise(r);
      });
    }, Promise.resolve()).then(function () {
      return dispatch({
        type: 'SET_STATUS_DONE'
      });
    });
  }, []);
  var actions = (0, _react.useMemo)(function () {
    return {
      fetchMatches: fetchMatches,
      executeWhileLoading: executeWhileLoading
    };
  }, [fetchMatches, executeWhileLoading]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MatchesActionsContext.Provider, {
    value: actions,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MatchesContext.Provider, {
      value: matches,
      children: children
    })
  });
};

var _default = MatchesProvider;
exports.default = _default;